import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['navbar']

  #scrollHandler = null

  connect() {
    this.triggerElement = document.querySelector('[data-navbar-trigger]')

    if (this.triggerElement) {
      this.observer = new IntersectionObserver(
        (entries) => this.#handleIntersection(entries),
        { rootMargin: `-${this.navbarHeight}px 0px 0px 0px`, threshold: 0 }
      )
      this.observer.observe(this.triggerElement)
    } else {
      this.#scrollHandler = () => this.#updateScrollState()
      window.addEventListener('scroll', this.#scrollHandler, { passive: true })
      this.#updateScrollState()
    }
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.#scrollHandler) {
      window.removeEventListener('scroll', this.#scrollHandler)
    }
  }

  #handleIntersection(entries) {
    entries.forEach((entry) => {
      this.navbarTarget.classList.toggle('is-scrolled', !entry.isIntersecting)
      this.dispatch(entry.isIntersecting ? 'transparent' : 'scrolled')
    })
  }

  #updateScrollState() {
    const isScrolled = window.scrollY > 0
    this.navbarTarget.classList.toggle('is-scrolled', isScrolled)
    this.dispatch(isScrolled ? 'scrolled' : 'transparent')
  }

  get navbarHeight() {
    return this.navbarTarget.offsetHeight
  }
}
